// Mock data for the Smart Farm Dashboard

export const dashboardStats = {
  farm: {
    count: 1,
    totalSize: 2.0,
    avgSize: 2.0,
    season: 7
  },
  sales: {
    total: 8395.00,
    avgOrderSize: 2798.33,
    avgWeight: 846.7
  },
  cost: {
    total: 82898.00,
    netProfit: -74503.00,
    profitMargin: -887
  },
  production: [
    { name: 'Nenas', weight: 10000, color: '#22c55e' },
    { name: 'Durian', weight: 10000, color: '#f59e0b' },
    { name: 'Tambikal', weight: 3000, color: '#ef4444' }
  ]
};

// Avialite LED Devices Data (API 2 - List Led Response Format)
export const avialiteDevices = [
  {
    ledId: 'LED001',
    stationId: 'STA001',
    note: 'Primary lighting system',
    id: 'LED001',
    // Additional fields for full API compliance
    gatewayId: 'GW001',
    farmerId: 'F001',
    farmId: 'farm1',
    vendorId: 'V001',
    farm: 'farm1', // Keep for existing farm filtering
    // Control-specific fields (API 5)
    brightness: 4,
    cmd: 'ON',
    // Legacy compatibility
    ledName: 'Farm Field A - North',
    stationName: 'Station A1',
    status: 'Good',
    state: 'On'
  },
  {
    ledId: 'LED002',
    stationId: 'STA002',
    note: 'Secondary lighting system',
    id: 'LED002',
    gatewayId: 'GW001',
    farmerId: 'F001',
    farmId: 'farm1',
    vendorId: 'V001',
    farm: 'farm1',
    brightness: 0,
    cmd: 'OFF',
    ledName: 'Farm Field A - South',
    stationName: 'Station A2',
    status: 'Fault',
    state: 'Off'
  },
  {
    ledId: 'LED003',
    stationId: 'STB001',
    note: 'Backup lighting system',
    id: 'LED003',
    gatewayId: 'GW002',
    farmerId: 'F002',
    farmId: 'farm2',
    vendorId: 'V001',
    farm: 'farm2',
    brightness: 3,
    cmd: 'ON',
    ledName: 'Farm Field B - East',
    stationName: 'Station B1',
    status: 'Good',
    state: 'On'
  },
  {
    ledId: 'LED004',
    stationId: 'STB002',
    note: 'Main field illumination',
    id: 'LED004',
    gatewayId: 'GW003',
    farmerId: 'F003',
    farmId: 'farm3',
    vendorId: 'V001',
    farm: 'farm3',
    brightness: 5,
    cmd: 'ON',
    ledName: 'Farm Field B - West',
    stationName: 'Station B2',
    status: 'Good',
    state: 'On'
  }
];

// HAVVA Camera List Data (API 2 - List Camera Response Format)
export const havvaDevices = [
  {
    cameraId: 'CAM001',
    note: 'Field Monitor Cam 1 - North Section',
    cameraStatus: 'Active',
    cameraQuality: 'High',
    recommendedActivity: 'Continue monitoring',
    id: 'CAM001',
    farm: 'farm1',
    farmerId: 'F001',
    farmId: 'farm1',
    vendorId: 'V001'
  },
  {
    cameraId: 'CAM002',
    note: 'Field Monitor Cam 2 - South Section',
    cameraStatus: 'Active',
    cameraQuality: 'Medium',
    recommendedActivity: 'Adjust camera angle',
    id: 'CAM002',
    farm: 'farm2',
    farmerId: 'F002',
    farmId: 'farm2',
    vendorId: 'V001'
  },
  {
    cameraId: 'CAM003',
    note: 'Greenhouse Monitor - Center',
    cameraStatus: 'Alert',
    cameraQuality: 'High',
    recommendedActivity: 'Check plant health',
    id: 'CAM003',
    farm: 'farm1',
    farmerId: 'F001',
    farmId: 'farm1',
    vendorId: 'V001'
  },
  {
    cameraId: 'CAM004',
    note: 'Perimeter Cam East - Boundary',
    cameraStatus: 'Active',
    cameraQuality: 'Low',
    recommendedActivity: 'Clean camera lens',
    id: 'CAM004',
    farm: 'farm3',
    farmerId: 'F003',
    farmId: 'farm3',
    vendorId: 'V001'
  }
];

// HAVVA Detail Analysis Data (API 6 - Detail Analysis Response Format)
export const havvaDetailAnalysis = [
  {
    cameraId: 'CAM001',
    timeStamp: '2025-09-26 10:30:28',
    leafDamage: 3,
    diseaseSpreadRate: 7,
    plantHeightVariation: 12,
    leafColorDeviation: 8,
    growthRateReduction: 17,
    recommendedActivity: 'Apply pesticide treatment within 48 hours',
    image: '/api/placeholder/300/200'
  },
  {
    cameraId: 'CAM002',
    timeStamp: '2025-09-26 10:25:15',
    leafDamage: 1,
    diseaseSpreadRate: 2,
    plantHeightVariation: 5,
    leafColorDeviation: 3,
    growthRateReduction: 4,
    recommendedActivity: 'Continue regular monitoring schedule',
    image: '/api/placeholder/300/200'
  },
  {
    cameraId: 'CAM003',
    timeStamp: '2025-09-26 09:45:33',
    leafDamage: 8,
    diseaseSpreadRate: 12,
    plantHeightVariation: 18,
    leafColorDeviation: 15,
    growthRateReduction: 25,
    recommendedActivity: 'Immediate intervention required - fungicide application',
    image: '/api/placeholder/300/200'
  },
  {
    cameraId: 'CAM004',
    timeStamp: '2025-09-26 11:15:42',
    leafDamage: 0,
    diseaseSpreadRate: 0,
    plantHeightVariation: 2,
    leafColorDeviation: 1,
    growthRateReduction: 0,
    recommendedActivity: 'Plants healthy - maintain current care routine',
    image: '/api/placeholder/300/200'
  }
];

// HAVVA Analysis History Data (API 5 - Analysis History Response Format)
export const havvaAnalysisHistory = [
  {
    cameraId: 'CAM001',
    timeStamp: '2025-09-26 10:30:28',
    recommendedActivity: 'Apply pesticide treatment within 48 hours',
    farmerId: 'F001',
    farmId: 'farm1',
    vendorId: 'V001'
  },
  {
    cameraId: 'CAM002',
    timeStamp: '2025-09-26 10:25:15',
    recommendedActivity: 'Continue regular monitoring schedule',
    farmerId: 'F002',
    farmId: 'farm2',
    vendorId: 'V001'
  },
  {
    cameraId: 'CAM003',
    timeStamp: '2025-09-26 09:45:33',
    recommendedActivity: 'Immediate intervention required - fungicide application',
    farmerId: 'F001',
    farmId: 'farm1',
    vendorId: 'V001'
  }
];

export const farmData = [
  {
    id: 'FARM001',
    farmName: 'DemoFarm SmartFarm',
    dateCreated: 'Tue, 17 Jun 2025',
    size: 2.0,
    season: 7,
    mobileNumber: '0123456789',
    location: 'Cyberjaya, Selangor',
    subscriptionEndDate: '17 Jun 2026',
    daysRemaining: 272
  }
];

export const analyticsData = {
  totalSales: 8395.00,
  totalCost: 82898.00,
  netProfit: -74503.00,
  profitMargin: -887.5,
  totalHarvest: 2660.0,
  totalSold: 2540.0,
  totalOrders: 3,
  avgSalesPerMonth: 932.78,
  avgOrderPerMonth: 0.0,
  avgCostPerMonth: 9210.89,
  avgOrderSize: 2798.33,
  avgPricePerKg: 3.31,
  avgMarginPerKg: -27.86
};

export const utilisationData = [
  {
    date: '11 Aug 2025',
    category: 'Fertilizer',
    material: 'AVIAT-IC CAP PUNGA (Baja Tahi Ayam Proses)',
    amount: '100kg',
    farm: 'DemoFarm SmartFarm',
    description: 'farm input'
  },
  {
    date: '11 Aug 2025',
    category: 'Fertilizer',
    material: 'NITROPHOSRA BLUE TF (12:12:17)',
    amount: '1000kg',
    farm: 'DemoFarm SmartFarm',
    description: 'farm input'
  },
  {
    date: '11 Aug 2025',
    category: 'Pesticide',
    material: 'ABIMEE 9.5SC',
    amount: '50kg',
    farm: 'DemoFarm SmartFarm',
    description: 'farm input'
  },
  {
    date: '16 Feb 2025',
    category: 'Pesticide',
    material: 'FORUM',
    amount: '0.032kg',
    farm: 'DemoFarm SmartFarm',
    description: 'Season: Seedless Red, SOP activity day: 47'
  },
  {
    date: '16 Feb 2025',
    category: 'Pesticide',
    material: 'PREVATHON 5SC',
    amount: '0.096l',
    farm: 'DemoFarm SmartFarm',
    description: 'Season: Seedless Red, SOP activity day: 47'
  }
];

export const stations = [
  { id: 'STA001', name: 'Station A1', location: 'North Field' },
  { id: 'STA002', name: 'Station A2', location: 'South Field' },
  { id: 'STB001', name: 'Station B1', location: 'East Field' },
  { id: 'STB002', name: 'Station B2', location: 'West Field' },
  { id: 'STC001', name: 'Station C1', location: 'Greenhouse' }
];

// ===================================
// 🚜 FARM MANAGEMENT DATABASE STRUCTURE
// ===================================

// Farms Database - Core farm information with Google Maps data and subscription info
export const farmsDatabase = [
  {
    id: 'farm_001',
    name: 'Green Valley Farm',
    size: '5.2 hectares',
    address: 'Lot 123, Jalan Pertanian Utama',
    postcode: '43000',
    city: 'Kajang',
    state: 'Selangor',
    country: 'Malaysia',
    coordinates: { lat: 2.9806, lng: 101.7807 },
    // Business & Subscription Information
    mobileNumber: '0123456789',
    farmerId: 'F001',
    subscriptionEndDate: '2025-06-17',
    subscriptionStatus: 'active',
    daysRemaining: 142,
    season: 7,
    // System Information
    createdAt: '2024-01-15T08:00:00Z',
    updatedAt: '2024-01-15T08:00:00Z',
    status: 'active'
  },
  {
    id: 'farm_002',
    name: 'Sunrise Organic Farm',
    size: '3.8 hectares',
    address: 'No. 456, Persiaran Hijau',
    postcode: '47000',
    city: 'Sungai Buloh',
    state: 'Selangor',
    country: 'Malaysia',
    coordinates: { lat: 3.2051, lng: 101.5744 },
    // Business & Subscription Information
    mobileNumber: '0198765432',
    farmerId: 'F002',
    subscriptionEndDate: '2025-12-25',
    subscriptionStatus: 'active',
    daysRemaining: 334,
    season: 3,
    // System Information
    createdAt: '2024-02-10T09:30:00Z',
    updatedAt: '2024-02-10T09:30:00Z',
    status: 'active'
  }
];

// Produce Types - Three main categories
export const produceTypes = [
  {
    id: 'agriculture',
    name: 'Agriculture',
    description: 'Traditional farming and crop cultivation',
    icon: '🌾',
    color: '#22c55e'
  },
  {
    id: 'aquaculture',
    name: 'Aquaculture',
    description: 'Fish farming and aquatic cultivation',
    icon: '🐟',
    color: '#3b82f6'
  },
  {
    id: 'veterinary',
    name: 'Veterinary',
    description: 'Livestock and animal husbandry',
    icon: '🐄',
    color: '#f59e0b'
  }
];

// Produce Categories - Subcategories for each type
export const produceCategories = [
  // Agriculture Categories
  { id: 'apiculture', name: 'Apiculture', type: 'agriculture', description: 'Beekeeping and honey production' },
  { id: 'cereal_crops', name: 'Cereal Crops', type: 'agriculture', description: 'Rice, wheat, corn cultivation' },
  { id: 'fruit_trees', name: 'Fruit Trees', type: 'agriculture', description: 'Orchard and fruit cultivation' },
  { id: 'vegetables', name: 'Vegetables', type: 'agriculture', description: 'Vegetable farming' },
  { id: 'herbs_spices', name: 'Herbs & Spices', type: 'agriculture', description: 'Herb and spice cultivation' },
  
  // Aquaculture Categories
  { id: 'freshwater_fish', name: 'Freshwater Fish', type: 'aquaculture', description: 'Freshwater fish farming' },
  { id: 'marine_fish', name: 'Marine Fish', type: 'aquaculture', description: 'Saltwater fish farming' },
  { id: 'shellfish', name: 'Shellfish', type: 'aquaculture', description: 'Crab, shrimp, oyster farming' },
  { id: 'aquatic_plants', name: 'Aquatic Plants', type: 'aquaculture', description: 'Seaweed and water plants' },
  
  // Veterinary Categories
  { id: 'poultry', name: 'Poultry', type: 'veterinary', description: 'Chicken, duck, turkey farming' },
  { id: 'cattle', name: 'Cattle', type: 'veterinary', description: 'Cow and buffalo farming' },
  { id: 'goats_sheep', name: 'Goats & Sheep', type: 'veterinary', description: 'Goat and sheep farming' },
  { id: 'swine', name: 'Swine', type: 'veterinary', description: 'Pig farming' }
];

// Produce Specifications - Detailed specifications for each category
export const produceSpecifications = {
  // Apiculture specifications
  apiculture: {
    types: ['Honey Production', 'Bee Breeding', 'Royal Jelly', 'Bee Pollen'],
    variants: ['Italian Bees', 'Carniolan Bees', 'Local Bees', 'Hybrid Bees'],
    startingStages: ['New Colony', 'Established Hive', 'Split Colony', 'Queen Introduction'],
    farmingProcesses: ['Traditional Hive', 'Modern Langstroth', 'Top Bar Hive', 'Organic Methods']
  },
  
  cereal_crops: {
    types: ['Rice', 'Corn', 'Wheat', 'Barley'],
    variants: ['Short Grain', 'Long Grain', 'Sweet Corn', 'Field Corn'],
    startingStages: ['Seed', 'Seedling', 'Transplant', 'Direct Seeding'],
    farmingProcesses: ['Conventional', 'Organic', 'SRI Method', 'Precision Farming']
  },
  
  fruit_trees: {
    types: ['Durian', 'Mango', 'Rambutan', 'Coconut', 'Palm Oil'],
    variants: ['D24', 'Musang King', 'Harumanis', 'Red Rambutan'],
    startingStages: ['Seed', 'Grafted Sapling', 'Young Tree', 'Mature Tree'],
    farmingProcesses: ['Traditional', 'Organic', 'Integrated Pest Management', 'Precision Agriculture']
  },
  
  vegetables: {
    types: ['Leafy Greens', 'Root Vegetables', 'Tomatoes', 'Peppers'],
    variants: ['Cabbage', 'Lettuce', 'Carrot', 'Cherry Tomato'],
    startingStages: ['Seed', 'Seedling', 'Transplant', 'Direct Seeding'],
    farmingProcesses: ['Hydroponic', 'Soil-based', 'Organic', 'Greenhouse']
  },
  
  // Additional categories for comprehensive coverage
  freshwater_fish: {
    types: ['Tilapia', 'Catfish', 'Carp', 'Trout'],
    variants: ['Red Tilapia', 'African Catfish', 'Grass Carp', 'Rainbow Trout'],
    startingStages: ['Fry', 'Fingerling', 'Juvenile', 'Adult Stock'],
    farmingProcesses: ['Pond Culture', 'Cage Culture', 'Tank Culture', 'Recirculating System']
  },
  
  poultry: {
    types: ['Broiler Chicken', 'Layer Chicken', 'Duck', 'Quail'],
    variants: ['Ross 308', 'Lohmann Brown', 'Pekin Duck', 'Japanese Quail'],
    startingStages: ['Day-old Chick', 'Grower', 'Finisher', 'Breeder'],
    farmerProcesses: ['Free Range', 'Cage System', 'Floor System', 'Organic']
  }
};

// Production Cycles Database - Links farms to their produce cycles
export const cyclesDatabase = [
  {
    id: 'cycle_farm_001_nenas_001',
    farmId: 'farm_001',
    produceType: 'Nenas',
    variant: 'MD2 Sweet Golden',
    quantity: 150,
    unit: 'plants',
    managementType: 'individual',
    seasonStartDate: '2024-01-15',
    expectedFirstHarvest: '2024-07-15',
    actualHarvestDate: '2024-07-20',
    actualYield: 145,
    expectedYield: 150,
    yieldUnit: 'kg',
    farmerProcess: 'organic',
    startingStage: 'seedling',
    currentStage: 'harvested',
    progress: 100,
    status: 'completed',
    completedAt: '2024-07-20T14:30:00Z',
    qrCodeId: 'QR_001',
    createdAt: '2024-01-15T08:00:00Z'
  },
  {
    id: 'cycle_farm_002_durian_001',
    farmId: 'farm_002',
    produceType: 'Durian',
    variant: 'Musang King',
    quantity: 25,
    unit: 'trees',
    managementType: 'individual',
    seasonStartDate: '2024-02-01',
    expectedFirstHarvest: '2024-08-01',
    actualHarvestDate: '2024-08-05',
    actualYield: 75,
    expectedYield: 500,
    yieldUnit: 'kg',
    farmerProcess: 'conventional',
    startingStage: 'flowering',
    currentStage: 'harvested',
    progress: 100,
    status: 'completed',
    completedAt: '2024-08-05T16:45:00Z',
    qrCodeId: 'QR_002',
    createdAt: '2024-02-01T09:00:00Z'
  },
  {
    id: 'cycle_farm_001_tomato_001',
    farmId: 'farm_001',
    produceType: 'Tomato',
    variant: 'Cherry Red',
    quantity: 50,
    unit: 'plants',
    managementType: 'batch',
    seasonStartDate: '2024-03-10',
    expectedFirstHarvest: '2024-06-10',
    expectedYield: 75,
    yieldUnit: 'kg',
    farmerProcess: 'organic',
    startingStage: 'seedling',
    currentStage: 'flowering',
    progress: 45,
    status: 'active',
    createdAt: '2024-03-10T10:30:00Z'
  }
];

// Activities Database - Farm diary and activity tracking
export const activitiesDatabase = [
  {
    id: 'activity_001',
    cycleId: 'cycle_001',
    farmId: 'farm_001',
    type: 'inspection',
    title: 'Hive Inspection',
    description: 'Weekly hive inspection for queen presence and brood pattern',
    scheduledDate: '2024-03-15',
    completedDate: null,
    status: 'planned',
    priority: 'high',
    notes: '',
    createdAt: '2024-03-01T08:00:00Z'
  },
  {
    id: 'activity_002',
    cycleId: 'cycle_001',
    farmId: 'farm_001',
    type: 'feeding',
    title: 'Sugar Syrup Feeding',
    description: 'Supplemental feeding during low nectar flow',
    scheduledDate: '2024-03-10',
    completedDate: '2024-03-10',
    status: 'completed',
    priority: 'medium',
    notes: 'Fed 2:1 sugar syrup, colonies responding well',
    createdAt: '2024-03-08T16:00:00Z'
  },
  {
    id: 'activity_003',
    cycleId: 'cycle_002',
    farmId: 'farm_002',
    type: 'fertilizing',
    title: 'Organic Fertilizer Application',
    description: 'Apply compost and organic fertilizer around tree base',
    scheduledDate: '2024-03-20',
    completedDate: null,
    status: 'planned',
    priority: 'high',
    notes: '',
    createdAt: '2024-03-15T09:00:00Z'
  }
];

// Farm Diary Statistics
export const farmDiaryStats = {
  cycle_001: {
    todayActivities: 2,
    plannedActivities: 5,
    completedActivities: 8,
    observations: 12,
    myGapReadiness: 75
  },
  cycle_002: {
    todayActivities: 1,
    plannedActivities: 3,
    completedActivities: 15,
    observations: 8,
    myGapReadiness: 85
  }
};
